module.exports = __webpack_public_path__ + "img/emptystate_wheelbarrow.575d8855.svg";